var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"relative",class:{ 'z-20' : _vm.isNavigationOpen },style:({ 'padding-top': `${_vm.headerHeight}px` }),attrs:{"id":"main-content"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }